import { render, staticRenderFns } from "./DoctorWorkresCarousel.vue?vue&type=template&id=e1c44a02"
import script from "./DoctorWorkresCarousel.vue?vue&type=script&lang=js"
export * from "./DoctorWorkresCarousel.vue?vue&type=script&lang=js"
import style0 from "./DoctorWorkresCarousel.vue?vue&type=style&index=0&id=e1c44a02&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports